import React from 'react'

import { Button, useMediaQueryContext } from '@fourthwall/components'

import * as S from './styled'
import type { Props } from './types'

export const FilterDropdownBox = ({ content, onReset, onSubmit }: Props) => {
  const media = useMediaQueryContext()

  return (
    <S.Container>
      <S.Content>
        <S.InnerContent>{content}</S.InnerContent>
      </S.Content>
      <S.Footer>
        <Button label="Reset" onClick={onReset} fullWidth={!media.tablet} />
        <Button
          type="submit"
          label="Done"
          appearance="primary"
          fullWidth={!media.tablet}
          onClick={onSubmit}
        />
      </S.Footer>
    </S.Container>
  )
}
